var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86719 14V5.46875H9.79102C10.7559 5.46875 11.4902 5.66211 11.9941 6.04883C12.498 6.43555 12.75 7.01172 12.75 7.77734C12.75 8.16797 12.6445 8.51953 12.4336 8.83203C12.2227 9.14453 11.9141 9.38672 11.5078 9.55859C11.9688 9.68359 12.3242 9.91992 12.5742 10.2676C12.8281 10.6113 12.9551 11.0254 12.9551 11.5098C12.9551 12.3105 12.6973 12.9258 12.1816 13.3555C11.6699 13.7852 10.9355 14 9.97852 14H6.86719ZM8.34961 10.1504V12.8164H9.99609C10.4609 12.8164 10.8242 12.7012 11.0859 12.4707C11.3477 12.2402 11.4785 11.9199 11.4785 11.5098C11.4785 10.623 11.0254 10.1699 10.1191 10.1504H8.34961ZM8.34961 9.06055H9.80273C10.2637 9.06055 10.623 8.95703 10.8809 8.75C11.1426 8.53906 11.2734 8.24219 11.2734 7.85938C11.2734 7.4375 11.1523 7.13281 10.9102 6.94531C10.6719 6.75781 10.2988 6.66406 9.79102 6.66406H8.34961V9.06055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoB);
export default __webpack_public_path__ + "static/media/ico-b.3e8794484c9bb1d11e186c1ec272ef38.svg";
export { ForwardRef as ReactComponent };